(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-in-stock-form"] && !Shopify.designMode) return;
  try {
    class BackInStockForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.msg = this.querySelector('.bis__msg');
      this.endpoint = this.dataset.endpoint;
      if (!this.form || this.form.dataset.bound) return;
      this.form.dataset.bound = '1';
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }

    show(text, isError) {
      this.msg.hidden = false;
      this.msg.textContent = text;
      this.msg.classList.toggle('is-error', !!isError);
    }

    succeed(text) {
      this.show(text, false);
      ['.bis__row', '.bis__check', '.bis__submit', '.bis__intro'].forEach((sel) => {
        const el = this.querySelector(sel);
        if (el) el.style.display = 'none';
      });
    }

    async onSubmit(event) {
      event.preventDefault();
      const fd = new FormData(this.form);
      if ((fd.get('company') || '').trim()) {
        this.succeed("Thanks - we'll be in touch.");
        return;
      }
      const email = (fd.get('email') || '').trim();
      if (!email) {
        this.show('Please enter your email address.', true);
        return;
      }
      const payload = {
        email: email,
        variant_id: fd.get('variant_id'),
        product_title: fd.get('product_title'),
        variant_title: fd.get('variant_title'),
        product_handle: fd.get('product_handle'),
        newsletter_opt_in: fd.get('newsletter_opt_in') ? true : false
      };
      const btn = this.querySelector('.bis__submit');
      btn.disabled = true;
      try {
        const res = await fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        let body = {};
        try { body = await res.json(); } catch (e) {}
        if (res.ok && body.ok) {
          const name = payload.product_title || 'this item';
          this.succeed("Done - we'll email " + email + " when " + name + " is back in stock.");
        } else {
          this.show('Sorry, something went wrong. Please check your email and try again.', true);
          btn.disabled = false;
        }
      } catch (err) {
        this.show('Network error - please try again in a moment.', true);
        btn.disabled = false;
      }
    }
  }

  if (!customElements.get('back-in-stock-form')) {
    customElements.define('back-in-stock-form', BackInStockForm);
  }
  } catch(e) { console.error(e); }
})();

})();
